import ClickOutside from 'react-click-outside';
export default ClickOutside as any;
